define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');
    var CheckboxReplacerModel = require('replacers/totalcasino-theme/checkbox/checkbox-tag.model');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        initialize: function(options) {
            var params = options.params;
            this.model = new CheckboxReplacerModel({
                name: params[0],
                tKey: params[1],
                ready: false
            });
            this.model
                .fetch()
                .fail(function(resp) {
                    this.showError(resp);
                    this.model.set('ready', false);
                }.bind(this));
        },

        events: {
            'change input[type=checkbox]': 'onCbValueChange'
        },

        subscribe: function() {
            this.listenTo(this.model, 'change:ready', this.render);
        },

        onCbValueChange: function(e) {
            var value = e.target.checked;
            this.model
                .save('value', value, { isDel: !value })
                .fail(this.showError.bind(this));
        },

        render: function() {
            this.$el.html(this.tmpl('checkbox.replacer', this.model.toJSON()));

            return this;
        }
    }, {
        nameOfReplacers: ['CHECKBOX']
    });
});
